import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions/";
import { defaultState } from "./lobby-model";

// actions
export const { Types, Creators } = createActions({
  lobbyShowLoading: [],
  lobbyHideLoading: [],
  lobbyDrawerShowLoading: [],
  lobbyDrawerHideLoading: [],
  lobbyInboundActiveShowLoading: [],
  lobbyInboundActiveHideLoading: [],
  lobbyInboundCheckinShowLoading: [],
  lobbyInboundCheckinHideLoading: [],
  lobbyEntryPermissionShowLoading: [],
  lobbyEntryPermissionHideLoading: [],
  lobbyHideDrawerVehicleEntryAuthorization: [],
  lobbyShowDrawerVehicleEntryAuthorization: [],
  lobbyUpdateStepEntryPermissionStatus: ["stepEntryPermissionStatus"],
  lobbyHasConfigurationLoaded: [],
  lobbyHasConfigurationNotLoaded: [],
  lobbyEnabledRegisterButton: [],
  lobbyDisabledRegisterButton: [],
  lobbyDisabledButtonSaveVehicle: [],
  lobbyEnabledButtonSaveVehicle: [],
  lobbyShowDrawerInbound: [],
  lobbyHideDrawerInbound: [],
  lobbyShowDrawerOutbound: [],
  lobbyHideDrawerOutbound: [],
  lobbyClearDocuments: [],
  lobbyCheckinClearDrivers: [],
  lobbySaleChannelActive: ["saleChannelActive"],
  lobbyProcessActive: ["processActive"],
  lobbyOutboundProcessActive: ["outboundProcessActive"],
  lobbyUpdateRegisterActive: ["registerActive"],
  lobbyCheckinUpdateRegisterActive: ["checkinRegisterActive"],
  lobbyRegistersActive: ["items", "totalItems"],
  lobbyShowDrawerViewRegister: [],
  lobbyHideDrawerViewRegister: [],
  lobbyShowDrawerCheckinRegister: [],
  lobbyHideDrawerCheckinRegister: [],
  lobbyShowModalVehicleAction: [],
  lobbyHideModalVehicleAction: [],
  lobbyUpdateDrawerViewMode: ["visibleDrawerViewMode"],
  lobbyUpdateFormModified: ["formViewOrEditModified"],
  lobbySaleChannelsList: ["salesChannelList"],
  lobbyInboundProcessesList: ["inboundProcessesList"],
  lobbyOutboundProcessesList: ["outboundProcessesList"],
  lobbyDocumentsList: ["documentsList"],
  lobbyUpdateFilterTable: ["searchFilter"],
  lobbyChangeFieldValue: ["fieldName", "value"],
  lobbyCheckinUpdateRegisterByVehiclePlateActive: ["checkinRegisterExisting"],
  lobbyUpdateVehicleProfileByPlate: ["vehicleProfileByPlate"],
  lobbyUpdateVehicleEntryAuthorizationRegisterActive: ["vehicleEntryAuthorizationRegisterActive"],
  lobbyDocumentsClearAsync: [],
  lobbyRegistersCheckins: ["itemsCheckins", "totalItemsCheckins"],
  lobbyChangeFieldValueCheckin: ["fieldName", "value"],
  lobbyUpdateEntryPermissionButtonClicked: [],
  lobbyUpdateHasConfiguration: [
    "hasCheckin",
    "allowRequestDockEntryAction",
    "allowRequestVehicleInboundAction",
    "hasFinishOperationAction",
    "allowRequestVehicleEntryAuthorizationAction",
    "hasAttendance",
    "hasSaleChannel",
    "hasScheduling",
    "documentType",
    "hasEntryPermission",
    "hasRfidReading",
    "plateFormatType",
  ],
  lobbyFetchAllActivesAsync: [],
  lobbyFetchItemAsync: ["yardRegisterId"],
  lobbySaveInboundAsync: ["bodyRequest"],
  lobbySaveOutboundAsync: ["body"],
  lobbyUpdateInboundAsync: ["bodyRequest", "form"],
  lobbySaveVehicleActionAsync: ["body"],
  lobbyDocumentsFetchAsync: ["processCorrelationId", "eventType"],
  lobbyFetchAllCheckinsAsync: [],
  lobbyFetchHasConfigurationAsync: [],
  lobbyFetchItemCheckinAsync: ["yardRegisterId"],
  lobbyInboundProcessesFetchAsync: [],
  lobbyOutboundProcessesFetchAsync: [],
  lobbySaleChannelsFetchAsync: [],
  lobbyFetchItemCheckinByVehiclePlateAsync: ["vehiclePlate"],
  lobbyFetchVehicleProfileByPlateAsync: ["vehiclePlate", "notifyExistingCheckin"],
  lobbyFetchItemVehicleEntryAuthorizationAsync: ["body"],
  lobbyFinishVehicleRegisterAsync: ["body"],
  lobbyUpdateEntryPermissionActive: ["entryPermissionActive"],
  lobbyFetchEntryPermissionAsync: ["vehiclePlate", "identificationDocument", "saleChannelId"],
});

//reducers
export const clearDocuments = (state = defaultState) => ({
  ...state,
  documentsList: [],
  registerActive: {
    ...state.registerActive,
    documents: [],
    cpf1: null,
    driver1: null,
  },
});

export const clearCheckinDrivers = (state = defaultState) => ({
  ...state,
  checkinRegisterActive: {
    ...state.checkinRegisterActive,
    documents: [],
    cpf1: "",
    driver1: "",
    drivers: [],
  },
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const drawerShowLoading = (state = defaultState) => ({
  ...state,
  drawerIsLoading: true,
});

export const drawerHideLoading = (state = defaultState) => ({
  ...state,
  drawerIsLoading: false,
});

export const showInboundActiveLoading = (state = defaultState) => ({
  ...state,
  isLoadingInboundActive: true,
});

export const hideInboundActiveLoading = (state = defaultState) => ({
  ...state,
  isLoadingInboundActive: false,
});

export const showInboundCheckinLoading = (state = defaultState) => ({
  ...state,
  isLoadingInboundCheckin: true,
});

export const hideInboundCheckinLoading = (state = defaultState) => ({
  ...state,
  isLoadingInboundCheckin: false,
});

export const entryPermissionShowLoading = (state = defaultState) => ({
  ...state,
  isLoadingEntryPermission: true,
});

export const entryPermissionHideLoading = (state = defaultState) => ({
  ...state,
  isLoadingEntryPermission: false,
});

export const hasConfigurationLoaded = (state = defaultState) => ({
  ...state,
  hasConfigurationLoaded: true,
});

export const hasConfigurationNotLoaded = (state = defaultState) => ({
  ...state,
  hasConfigurationLoaded: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: false,
});

export const disabledButtonSaveVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonSaveVehicle: true,
});

export const enabledButtonSaveVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonSaveVehicle: false,
});

export const showDrawerInbound = (state = defaultState) => ({
  ...state,
  visibleDrawerInbound: true,
});

export const hideDrawerInbound = (state = defaultState) => ({
  ...state,
  visibleDrawerInbound: false,
  stepEntryPermissionStatus: 0,
  entryPermissionActive: defaultState.entryPermissionActive,
});

export const showDrawerOutbound = (state = defaultState) => ({
  ...state,
  visibleDrawerOutbound: true,
});

export const hideDrawerOutbound = (state = defaultState) => ({
  ...state,
  visibleDrawerOutbound: false,
});

export const updateRegisterActive = (state, action: any) => ({
  ...state,
  registerActive: {
    ...action.registerActive,
    processId: action.registerActive.processId,
  },
});

export const showDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegister: true,
});

export const hideDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegister: false,
  stepEntryPermissionStatus: 0,
  entryPermissionActive: defaultState.entryPermissionActive,
});

export const updateDrawerViewMode = (state, action: any) => ({
  ...state,
  visibleDrawerViewMode: action.visibleDrawerViewMode,
});

export const updateEntryPermissionButtonClicked = (state) => ({
  ...state,
  entryPermissionActive: {
    ...state.entryPermissionActive,
    verified: true,
  },
});

export const updatformViewOrEditModified = (state, action: any) => ({
  ...state,
  formViewOrEditModified: action.formViewOrEditModified,
});

export const setInboundProcessesList = (state, { inboundProcessesList }) => ({
  ...state,
  ...inboundProcessesList,
});

export const setOutboundProcessesList = (state, { outboundProcessesList }) => ({
  ...state,
  ...outboundProcessesList,
});

export const setSaleChannelsList = (state, { salesChannelList }) => ({
  ...state,
  ...salesChannelList,
});

export const setDocumentsList = (state, { documentsList }) => ({
  ...state,
  ...documentsList,
});

export const updateFilterTable = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.searchFilter,
  };
};

export const registerActive = (state, { items, totalItems }) => ({
  ...state,
  items,
  totalItems,
});

export const registerCheckins = (state, { itemsCheckins, totalItemsCheckins }) => ({
  ...state,
  itemsCheckins,
  totalItemsCheckins,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filterActive: onChangeFieldValue(state.filterActive, fieldName, value),
});

export const changeFieldValueCheckin = (state, { fieldName, value }) => ({
  ...state,
  filterCheckin: onChangeFieldValue(state.filterCheckin, fieldName, value),
});

export const updateHasConfiguration = (
  state,
  {
    hasCheckin,
    allowRequestDockEntryAction,
    allowRequestVehicleInboundAction,
    hasFinishOperationAction,
    allowRequestVehicleEntryAuthorizationAction,
    hasAttendance,
    hasSaleChannel,
    hasScheduling,
    documentType,
    hasEntryPermission,
    hasRfidReading,
    plateFormatType,
  }
) => ({
  ...state,
  hasCheckin,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  hasFinishOperationAction,
  allowRequestVehicleEntryAuthorizationAction,
  hasAttendance,
  hasSaleChannel,
  hasScheduling,
  documentType,
  hasEntryPermission,
  hasRfidReading,
  plateFormatType,
});

export const showDrawerCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerCheckinRegister: true,
});

export const hideDrawerCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerCheckinRegister: false,
  stepEntryPermissionStatus: 0,
  entryPermissionActive: defaultState.entryPermissionActive,
});

export const updateCheckinRegisterActive = (state, action: any) => ({
  ...state,
  checkinRegisterActive: {
    ...action.checkinRegisterActive,
    processId: action.checkinRegisterActive.processId,
  },
});

export const updateProcessActive = (state, action: any) => {
  return {
    ...state,
    processActive: action.processActive,
  };
};

export const updateSaleChannelActive = (state, action: any) => {
  return {
    ...state,
    saleChannelActive: action.saleChannelActive,
  };
};

export const updateOutboundProcessActive = (state, action: any) => {
  return {
    ...state,
    outboundProcessActive: action.outboundProcessActive,
  };
};

export const showModalVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalVehicleAction: true,
});

export const hideModalVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalVehicleAction: false,
});

export const updateCheckinRegisterExistingActive = (state, action: any) => {
  return {
    ...state,
    checkinRegisterExisting: action.checkinRegisterExisting,
  };
};

export const updateVehicleProfileByPlate = (state, action: any) => ({
  ...state,
  vehicleProfileByPlate: action.vehicleProfileByPlate,
});

export const showDrawerVehicleEntryAuthorization = (state = defaultState) => ({
  ...state,
  visibleDrawerVehicleEntryAuthorization: true,
});

export const hideDrawerVehicleEntryAuthorization = (state = defaultState) => ({
  ...state,
  visibleDrawerVehicleEntryAuthorization: false,
});

export const updateVehicleEntryAuthorizationRegisterActive = (state, { vehicleEntryAuthorizationRegisterActive }: any) => ({
  ...state,
  vehicleEntryAuthorizationRegisterActive,
});

export const updateStepEntryPermissionStatus = (state, action: any) => ({
  ...state,
  stepEntryPermissionStatus: action.stepEntryPermissionStatus,
});

export const updateEntryPermissionActive = (state, { entryPermissionActive }) => ({
  ...state,
  entryPermissionActive,
});

// map reducer to action
export default createReducer(defaultState, {
  [Types.LOBBY_SHOW_LOADING]: showLoading,
  [Types.LOBBY_HIDE_LOADING]: hideLoading,
  [Types.LOBBY_DRAWER_SHOW_LOADING]: drawerShowLoading,
  [Types.LOBBY_DRAWER_HIDE_LOADING]: drawerHideLoading,
  [Types.LOBBY_ENTRY_PERMISSION_SHOW_LOADING]: entryPermissionShowLoading,
  [Types.LOBBY_ENTRY_PERMISSION_HIDE_LOADING]: entryPermissionHideLoading,
  [Types.LOBBY_INBOUND_ACTIVE_SHOW_LOADING]: showInboundActiveLoading,
  [Types.LOBBY_INBOUND_ACTIVE_HIDE_LOADING]: hideInboundActiveLoading,
  [Types.LOBBY_INBOUND_CHECKIN_SHOW_LOADING]: showInboundCheckinLoading,
  [Types.LOBBY_INBOUND_CHECKIN_HIDE_LOADING]: hideInboundCheckinLoading,
  [Types.LOBBY_SHOW_DRAWER_VEHICLE_ENTRY_AUTHORIZATION]: showDrawerVehicleEntryAuthorization,
  [Types.LOBBY_HIDE_DRAWER_VEHICLE_ENTRY_AUTHORIZATION]: hideDrawerVehicleEntryAuthorization,
  [Types.LOBBY_HAS_CONFIGURATION_LOADED]: hasConfigurationLoaded,
  [Types.LOBBY_UPDATE_STEP_ENTRY_PERMISSION_STATUS]: updateStepEntryPermissionStatus,
  [Types.LOBBY_HAS_CONFIGURATION_NOT_LOADED]: hasConfigurationNotLoaded,
  [Types.LOBBY_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.LOBBY_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
  [Types.LOBBY_DISABLED_BUTTON_SAVE_VEHICLE]: disabledButtonSaveVehicle,
  [Types.LOBBY_ENABLED_BUTTON_SAVE_VEHICLE]: enabledButtonSaveVehicle,
  [Types.LOBBY_SHOW_DRAWER_INBOUND]: showDrawerInbound,
  [Types.LOBBY_HIDE_DRAWER_INBOUND]: hideDrawerInbound,
  [Types.LOBBY_SHOW_DRAWER_OUTBOUND]: showDrawerOutbound,
  [Types.LOBBY_HIDE_DRAWER_OUTBOUND]: hideDrawerOutbound,
  [Types.LOBBY_UPDATE_REGISTER_ACTIVE]: updateRegisterActive,
  [Types.LOBBY_SHOW_DRAWER_VIEW_REGISTER]: showDrawerViewRegister,
  [Types.LOBBY_HIDE_DRAWER_VIEW_REGISTER]: hideDrawerViewRegister,
  [Types.LOBBY_UPDATE_DRAWER_VIEW_MODE]: updateDrawerViewMode,
  [Types.LOBBY_UPDATE_FORM_MODIFIED]: updatformViewOrEditModified,
  [Types.LOBBY_INBOUND_PROCESSES_LIST]: setInboundProcessesList,
  [Types.LOBBY_OUTBOUND_PROCESSES_LIST]: setOutboundProcessesList,
  [Types.LOBBY_SALE_CHANNELS_LIST]: setSaleChannelsList,
  [Types.LOBBY_DOCUMENTS_LIST]: setDocumentsList,
  [Types.LOBBY_CLEAR_DOCUMENTS]: clearDocuments,
  [Types.LOBBY_CHECKIN_CLEAR_DRIVERS]: clearCheckinDrivers,
  [Types.LOBBY_REGISTERS_ACTIVE]: registerActive,
  [Types.LOBBY_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.LOBBY_UPDATE_FILTER_TABLE]: updateFilterTable,
  [Types.LOBBY_REGISTERS_CHECKINS]: registerCheckins,
  [Types.LOBBY_CHANGE_FIELD_VALUE_CHECKIN]: changeFieldValueCheckin,
  [Types.LOBBY_UPDATE_HAS_CONFIGURATION]: updateHasConfiguration,
  [Types.LOBBY_SHOW_DRAWER_CHECKIN_REGISTER]: showDrawerCheckinRegister,
  [Types.LOBBY_HIDE_DRAWER_CHECKIN_REGISTER]: hideDrawerCheckinRegister,
  [Types.LOBBY_SHOW_MODAL_VEHICLE_ACTION]: showModalVehicleAction,
  [Types.LOBBY_HIDE_MODAL_VEHICLE_ACTION]: hideModalVehicleAction,
  [Types.LOBBY_CHECKIN_UPDATE_REGISTER_ACTIVE]: updateCheckinRegisterActive,
  [Types.LOBBY_CHECKIN_UPDATE_REGISTER_BY_VEHICLE_PLATE_ACTIVE]: updateCheckinRegisterExistingActive,
  [Types.LOBBY_UPDATE_VEHICLE_PROFILE_BY_PLATE]: updateVehicleProfileByPlate,
  [Types.LOBBY_PROCESS_ACTIVE]: updateProcessActive,
  [Types.LOBBY_SALE_CHANNEL_ACTIVE]: updateSaleChannelActive,
  [Types.LOBBY_OUTBOUND_PROCESS_ACTIVE]: updateOutboundProcessActive,
  [Types.LOBBY_UPDATE_VEHICLE_ENTRY_AUTHORIZATION_REGISTER_ACTIVE]: updateVehicleEntryAuthorizationRegisterActive,
  [Types.LOBBY_UPDATE_ENTRY_PERMISSION_ACTIVE]: updateEntryPermissionActive,
  [Types.LOBBY_UPDATE_ENTRY_PERMISSION_BUTTON_CLICKED]: updateEntryPermissionButtonClicked,
});
